export default "__VITE_ASSET__BIAVO$Wf__"